import { DSThemeProvider } from "@vr/ds-react";
import { PropsWithChildren } from "react";

export default function AppProvider({ children }: Readonly<PropsWithChildren>) {
  return (
    <DSThemeProvider emissor="VRPAT">
      <>{children}</>
    </DSThemeProvider>
  );
}
